<template lang="pug">
  .component-selectize-vehicle
    selectize(v-if="options", :selectedValue="selectedValue", :options="options", value-field="id", :maxItems="maxItems" label-field="plate", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :disabled="disabled", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Vehicle Type", @itemRemoved="optionRemoved")
</template>

<script>
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
  import BaseSelectize from './BaseSelectize'
  import Selectize from "../../../Selectize";

  export default {
    name: "SelectizeVehicleType",
    extends: BaseSelectize,
    components: {Selectize},
    data() {
      return {
        searchableFields: [
          'id',
          'name',
        ],
      }
    },
    created() {
      KeplerBackofficeSdk.vehicleTypes.list.all((data) => {
        this.options = data
      })
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div>VA${item.id} ${item.name}</div><div><small>${item.description}</small></div></div>`
      },
      renderTemplate(item, escape) {
        return `<div>VA${item.id} ${item.name}</div>`
      },
      optionsLoader() {

      }
    },
    props: ['selectedValue']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeVehicleType.vue?6a257e5c